const dispatchNetworkEvent = (name, detail = {}) => {
	if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;

	let event = null;

	if (typeof window.CustomEvent === 'function') event = new window.CustomEvent(name, { detail });

	else if (typeof document !== 'undefined' && typeof document.createEvent === 'function') {
		event = document.createEvent('CustomEvent');
		event.initCustomEvent(name, false, false, detail);
	}

	if (event) window.dispatchEvent(event);
};

export { dispatchNetworkEvent };
